import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import TabsMui from '../../layout/TabsMui'
import LoadingScreen from '../LoadingScreen'
import MobilePaginationBar from './MobilePaginationBar'

export default function MobileTabbedReportLayout({
  tabs,
  activeTab,
  onTabChange,
  hasError,
  isFetching,
  loadingText = 'Cargando...',
  loadingMinHeight,
  filterContent = null,
  actionContent = null,
  children,
  currentPage,
  totalPages,
  showPagination = totalPages > 1,
  paginationDisabled = false,
  onPaginationPageChange,
  handlePaginationClick,
  contentPaddingX = 1.5
}) {
  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, pb: 3 }}>
      <TabsMui tabs={tabs} activeTab={activeTab} onChange={onTabChange} scrollable />

      {hasError && !isFetching ? (
        <Box role="alert" sx={{ mx: 1.5, my: 2, p: 2, bgcolor: 'error.light', borderRadius: 1 }}>
          <Typography component="span" variant="body2" fontWeight={700}>
            Hubo un error al traer los datos. Intenta nuevamente.
          </Typography>
        </Box>
      ) : null}

      {isFetching ? (
        <LoadingScreen text={loadingText} minHeight={loadingMinHeight} />
      ) : (
        <Stack spacing={2} sx={{ px: contentPaddingX }}>
          {filterContent}
          {actionContent}
          {children}
          {showPagination ? (
            <MobilePaginationBar
              disabled={paginationDisabled}
              current_page={currentPage}
              total_pages={totalPages}
              disablePaper
              onPageChange={onPaginationPageChange}
              handle_pagination={handlePaginationClick}
            />
          ) : null}
        </Stack>
      )}
    </Box>
  )
}
